
export function getContextInjections() {
  return {
    defaultLocale: {
      from: 'locale',
      default: 'en-US'
    },
    defaultCurrency: {
      from: 'currency',
      default: 'USD'
    }
  }
}

export function getContext(vm) {
  return {
    locale: vm.defaultLocale,
    currency: vm.defaultCurrency
  }
}
